<template>
  <article class="format">
    <div class="format__heart" @click="toggleFavorite" :class="{'format__heart--active': formatIsFavorited}"></div>
    <router-link v-if="userIsAdmin" :to="{path: '/admin#formats', query: {id}}" class="button button--tertiary format__button__adminedit">Edit</router-link>
    <figure class="format__image" v-on:click="showFormatDetail">
      <img :src="previewImage()" class="format__image__source" />
    </figure>

    <div class="format__content">
      <header class="format__header">
        <h1 class="format__title">{{ title }}</h1>
        <button v-if="premium" class="button button--primary format__button__premium">Pro only</button>
      </header>

      <p class="format__text">{{ getDescription }}&hellip;<p>

      <div class="format__buttons">
        <span :data-v-home-step="getUseStepHome" class="format__button button button--primary button--expand" v-on:click="showFormatDetail">Create One</span>
        <span :data-v-home-step="getDemoStepHome" class="format__button button button--tertiary button--expand" v-on:click="viewDemo">View Media Kit &amp; Samples</span>
      </div>

      <footer class="format__footer">
        <SeriesBadge :series="series" :box="true"/>
        <div class="format__size__container">
          <h2 class="format__sizes">Supported Sizes</h2>
          <p class="format__formats">{{ getSizes }}</p>
        </div>
      </footer>
    </div>
  </article>
</template>

<script>
import {mapState} from 'vuex'
import SeriesBadge from './SeriesBadge.vue'

  export default {
    name: 'format-item',
    components: {
      SeriesBadge,
    },
    props: ['index', 'premium', 'title', 'id', 'categoryId', 'preview_icon', 'formatdata', 'preview_image', 'description', 'series'],
    methods: {
      showFormatDetail () {
        this.$router.push({
          path: `/configuration/${this.id}`
        });
        /*
        this.$modal.show('format-detail', {id: this.id})
        setTimeout(() => {
          if (this.$tours['long_tour'].currentStep === 5) {
            this.$tours['long_tour'].nextStep();
          }
        }, 10)
        */
      },
      viewDemo () {
        let route = this.$router.resolve({path: `/demo/${this.id}`});
        window.open(route.href, '_blank')
      },
      previewImage () {
        return this.preview_image || 'data:image/svg+xml;base64,' + btoa(this.preview_icon);
      },
      toggleFavorite () {
        if (this.me.id) {
          if (this.formatIsFavorited) {
            this.unfavorite()
          } else {
            this.favorite()
          }
        } else {
          this.$modal.show('intersection')
        }
      },
      favorite () {
        this.$store.dispatch('users/addFavorite', {format_id: this.id})
      },
      unfavorite () {
        this.$store.dispatch('users/removeFavorite', { id: this.favorited.id })
      }
    },
    computed: {
      ...mapState('users', ['favorites']),
      ...mapState(['me']),
      userIsAdmin () {
        return this.me.admin
      },
      getSizes() {
        let sizes = [];
        let input = JSON.parse(this.formatdata).inputs;
        for (var i = 0; i < input.length; i++) {
          if (input[i].type === 'size') {
            for (var v = 0; v < input[i].options.length; v++) {
              if (input[i].options[v].type === 'flexible') {
                sizes.push(`${input[i].options[v].width}:${input[i].options[v].height}`);
              } else {
                sizes.push(`${input[i].options[v].width}x${input[i].options[v].height}`);
              }
            }
            return sizes.join(', ');
          }
        }
        return 'One Size Fits All';
      },
      getDescription () {
        if (this.description === '' || this.description == null) {
          let format = JSON.parse(this.formatdata);
          this.displayDescription = (format.description || 'No description provided').substring(0, 275)
        } else {
          this.displayDescription = this.description
        }

        return this.displayDescription
      },
      getDemoStep () {
        if (this.index === 0) {
          return 4
        } else {
          return null
        }
      },
      getUseStep () {
        if (this.index === 0) {
          return 5
        } else {
          return null
        }
      },
      getDemoStepHome () {
        if (this.index === 0) {
          return 4
        } else {
          return null
        }
      },
      getUseStepHome () {
        if (this.index === 0) {
          return 3
        } else {
          return null
        }
      },
      formatIsFavorited () {
        let rtnVal = false;
        if (this.favorites.length) {
          this.favorites.forEach(favorite => {
            if (favorite.format_id == this.id) {
              this.favorited = favorite;
              rtnVal = true
            }
          })
        }
        return rtnVal;
      }
    },
    data () {
      return {
        displayDescription: null,
        favorited: null,
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/common/FormatItem.vue